import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCTA() {
  return <section className="w-full bg-navy-950 py-14 text-white md:py-20" aria-labelledby="final-title" data-id="element-131" data-mp="3mujt7fpda4qk">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-132" data-mp="3rrtj0wgo4iex">
        <div className="text-center" data-id="element-133" data-mp="3rqiid5iirqs1">
          <h2 id="final-title" className="font-display text-[26px] font-black uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-134" data-mp="3dsu2kc3b79tu">
            Ready To Take Control Of Your Aligner Workflow?
          </h2>
          <p className="mt-3 font-display text-[17px] font-bold text-brand-400 sm:text-xl" data-id="element-135" data-mp="33x0kyeaqgq57">
            Organize your next case in 15 minutes
          </p>
          <p className="mx-auto mt-4 max-w-xl text-[14px] leading-relaxed text-brand-100/80 sm:text-[15px]" data-id="element-136" data-mp="1239kzge3561l">
            Instead of opening multiple resources and trying to remember where everything belongs, use a
            structured visual command center to organize your case.
          </p>
        </div>

        <div className="mt-8 rounded-3xl bg-white/[0.06] px-5 py-7 ring-1 ring-white/10 sm:px-8" data-id="element-137" data-mp="l8h9yqbikr8z">
          <p className="text-center font-display text-[11px] font-bold uppercase tracking-[0.2em] text-brand-400" data-id="element-138" data-mp="yzvytds3rmny">
            Today’s price
          </p>
          <p className="mt-2 text-center font-display text-6xl font-black leading-none text-white sm:text-7xl" data-id="element-139" data-mp="79rgrlrtfbpw">
            $27
            <span className="ml-2 align-middle font-display text-xl font-bold text-brand-100/70" data-id="element-140" data-mp="2bg6xb1it17o">USD</span>
          </p>
          <p className="mt-2 text-center text-[13px] font-semibold text-brand-100/60" data-id="element-141" data-mp="gb8rspqd8n7q">
            Real perceived value: <span className="line-through" data-id="element-142" data-mp="b9t9h5fkout1">$441 USD</span>
          </p>
          <p className="mt-3 flex items-center justify-center gap-2 text-center text-[12px] font-semibold text-brand-100/85" data-id="element-143" data-mp="1rotbn1djor9b">
            <GlobeIcon className="h-4 w-4 shrink-0 text-brand-400" aria-hidden="true" data-id="element-144" data-mp="1mpzxd6qfow83" />
            Currency conversion is applied automatically
          </p>

          <div className="mt-7" data-id="element-145" data-mp="pboqk66af04o">
            <CTAButton tone="gold" onDark subtext="Instant download · One-time payment · Lifetime access · 7-day guarantee" data-id="element-146" data-mp="pan475jtmr7n" />
          </div>

          <div className="mt-7" data-id="element-147" data-mp="ybl8loy690qr">
            <Countdown data-id="element-148" data-mp="yaik1nobnae0" />
          </div>

          <div className="mt-5" data-id="element-149" data-mp="1nf2exllq0ad">
            <ScarcityBar percentTaken={93} spotsLeft={9} note="Once the launch promotion ends, the price may return to the regular price." data-id="element-150" data-mp="1ognzw08u56c" />
          </div>
        </div>
      </div>
    </section>;
}